import headerV2PC from '@/components/pc/common/headerV2PC.vue'
import footerPC from '@/components/pc/common/footerPC.vue'
import rankingIndexViewPC from '@/views/pc/ranking/RankingIndexViewPC.vue'
import othersViewPC from '@/views/pc/others/OthresViewPC.vue'
import { disableHeaderActive } from "@/utils/topic/topicUtils";
import store from "@/store";
import { promoteUrl } from "@/utils/url";
/**
 * @description
 * * components 说明:
 * - 在 components: { [key]: ... } 的配置，会在对应的 <router-view name="[key]"> 里呈现
 * - 页面主要内容: default
 * - 可全局加载的共用元件: 依照页面情境选择性添加，好比 header, footer, sidebar...
 * * components 对应画面处理说明:
 * - 在 layoutPC 里处理上述 components 元件在画面上放置的位置
 */
const routesPC = [
  {
    path: '/',
    name: 'home',
    components: {
      headerPC: headerV2PC,
      default: () => import('@/views/pc/home/HomeViewPC.vue'),
      footerPC,
    },
    meta: {
      title: '抖圈 - 为du而生',
      keepAlive: false
    }
  },
  { //老哥故事. 老姐故事. 官方
    path:'/forum/:fid/:type?',
    name:'forum',
    components: {
      headerPC: headerV2PC,
      default: () => import('@/views/pc/home/HomeViewPC.vue'),
      footerPC,
    },
    meta: {
      title: '抖圈 - 为du而生',
      keepAlive: false
    }
  },
  // {
  //   path: '/testpages',
  //   name: 'testpages',
  //   components: {
  //     headerPC,
  //     default: () => import('@/components/pc/test/testPages'),
  //     footerPC
  //   },
  //   meta: {
  //     title: '頁碼組件測試',
  //     keepAlive: true
  //   }
  // },
  // {
  //   path: '/testiframe',
  //   name: 'testiframe',
  //   components: {
  //     default: () => import('@/components/pc/test/testIframe'),
  //   },
  //   meta: {
  //     title: 'iframe彈窗測試',
  //     keepAlive: true
  //   }
  // },
  // {
  //   path: '/testlottie',
  //   name: 'testlottie',
  //   components: {
  //     default: () => import('@/components/pc/test/testLottie'),
  //   },
  //   meta: {
  //     title: 'lottie動畫測試',
  //     keepAlive: true
  //   }
  // },
  {
    path: '/signpopup',
    name: 'signpopup',
    components: {
      default: () => import('@/components/pc/popup/SignPopupPC'),
    },
    meta: {
      title: '簽到',
      keepAlive: true
    }
  },
  {
    path: '/user/:userId/profile',
    redirect: to => {
      return '/user/'+to.params.userId+'/thread'
    }
  },
  {
    path: '/user/:userId/:do/:type?',
    name:'user',
    components: {
      headerPC:headerV2PC,
      default: () => import('@/views/pc/user/UserFrame'),
      footerPC,
    },
  },
  {
    // 话题
    path: '/topic/:id(\\d+)/:query*',
    name: 'topic',
    meta:{
      title: '话题',
      keepAlive: false
    },
    components: {
      headerPC:headerV2PC,
      default:()=> import('@/views/pc/topic/TopicViewPC.vue'),
      footerPC,
    }
  },
  {
    // 排行榜
    path: '/ranking',
    components:{
      headerPC:headerV2PC,
      default:rankingIndexViewPC,
      footerPC,
    },
    children:[
      {
        path:'topic/:page(\\d+)*',
        name:'topicrank',
        meta:{
          title: '话题排行榜',
          keepAlive: false
        },
        component:()=> import('@/views/pc/ranking/pages/TopicRankingViewPC.vue'),
      },
      {
        path: "betking/:switch?",
        name: 'ranking-betking',
        meta: {
          title: '英雄榜',
          tabbarKey: 'ranking'
        },
        component: () => import('@/views/pc/ranking/pages/BetkingRankingViewPC.vue'),
      },
      {
        path: "fomi",
        name: 'ranking-fomi',
        meta: {
          title: '福米榜',
          tabbarKey: 'ranking'
        },
        // TODO: 改成 vue
        // component: () => import('@/views/pc/ranking/pages/FomiRankingViewPC.vue'),
        beforeEnter: (to) => {
          store.dispatch("common/handleLoading", true)
          store.dispatch("common/closeRedirectLoadingInterval")
          window.location.replace( promoteUrl() + '/ranking.php?mod=fomi')
        }
      },
    ]
  },
  {
    // 其他
    path: '/others',
    components:{
      headerPC:headerV2PC,
      default: othersViewPC,
      footerPC,
    },
    children:[
      {
        path:'rule',
        name:'rule',
        meta:{
          title: '社区规则 - 为du而生',
          keepAlive: false
        },
        component:()=> import('@/views/pc/others/pages/RulePC.vue'),
      },
      {
        path:'privacy',
        name:'privacy',
        meta:{
          title: '隐私说明 - 为du而生',
          keepAlive: false
        },
        component:()=> import('@/views/pc/others/pages/PrivacyPC.vue'),
      },
      {
        path:'aboutus',
        name:'aboutus',
        meta:{
          title: '关于我们 - 为du而生',
          keepAlive: false
        },
        component:()=> import('@/views/pc/others/pages/AboutUsPC.vue'),
      },
      {
        path:'appdownload',
        name:'appdownload',
        meta:{
          title: 'APP下载 - 为du而生',
          keepAlive: false
        },
        component:()=> import('@/views/pc/others/pages/AppDownloadPC.vue'),
      },
    ]
  },
  {
    // 搜索
    path: '/search/:keyword/:type?',
    name: 'search',
    meta:{
      title: '搜索',
      keepAlive: false
    },
    components: {
      headerPC:headerV2PC,
      default:()=> import('@/views/pc/search/SearchViewPC.vue'),
      footerPC,
    }
  },
  /**
   * 錯誤頁面
   */
  {
    path: '/:catchAll(.*)',
    name: 'Error404',
    components: {
      default:()=> import('@/views/pc/errors/Error404PC')
    }
  },
]

routesPC.forEach((el) => {
  if(!el.meta) el.meta = {}
  el.meta.layout = 'layoutPC'
})

export default routesPC
